import React, { useRef, useEffect, useState } from "react";
import ModalDefault from "../../modalDefault.js";

import { DataTable } from "mantine-datatable";
import { toast } from "react-hot-toast";
import {
  ApiGetAllComidas,
  ApiActivarDesactivarComida,
  ApiDeleteComida,
} from "../../../api/comidas.js";
import { ActionIcon, Group, TextInput, Switch } from "@mantine/core";
import ComidaImage from "../../../assets/platoComida.webp"

const BATCH_SIZE = 12;
const TablaOpciones = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [allComidas, setAllComidas] = useState([]); // Estado para todas los comidas
  const [filteredComidas, setFilteredComidas] = useState([]); // Estado para comidas filtradas
  const [fetching, setfetching] = useState(true);
  const [selectedComida, setSelectedComida] = useState(null);

  // Estados para scroll infinito y filtros
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const [queryNombreComida, setQueryNombreComida] = useState("");
  const [queryCostoComida, setQueryCostoComida] = useState("");
  const [queryHoraInicio, setQueryHoraInicio] = useState("");
  const [queryHoraFin, setQueryHoraFin] = useState("");
  const scrollViewportRef = useRef(null);

  //ordenamiento
  const [isInit, setIsInit] = useState(false);
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "",
    direction: "asc",
  });

  const columns = [
    {
      accessor: "nombre",
      title: "Comida",
      textAlignment: "center",
      filter: (
        <TextInput
          placeholder="Buscar por comida..."
          value={queryNombreComida}
          onChange={(e) => setQueryNombreComida(e.currentTarget.value)}
        />
      ),
      filtering: queryNombreComida !== "",
    },
    {
      accessor: "imagen",
      title: "Imagen",
      textAlignment: "center",
      render: () => (
        <img
          src={ComidaImage}
          alt="plato comida"
          style={{ width: "50px", height: "50px" }}
        />
      ),
    },
    {
        accessor: "costo",
        title: "Costo",
        textAlignment: "center",
        sortable: true,
    },
    {
      accessor: "hora_inicio",
      title: "Hora de Inicio ",
      textAlignment: "center",
    },
    {
      accessor: "hora_fin",
      title: "Hora de fin",
      textAlignment: "center",
    },
    {
      accessor: "activo",
      title: "Estado",
      textAlignment: "center",
      render: (record) => toggle(record),
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  useEffect(() => {
    init();
  }, [props.updateList]);

  const init = async () => {
    setfetching(true);
    const { data } = await ApiGetAllComidas();
    const filterComidas = data.filter((comida) => comida.estado === true ); 
    setAllComidas(filterComidas);
    setFilteredComidas(filterComidas);
    setfetching(false);
    setIsInit(true);
  };

  // Logica para filtros
  useEffect(() => {
    const filtered = allComidas.filter(
      (comidas) =>
        comidas.nombre.toLowerCase().includes(queryNombreComida.toLowerCase()) &&
        comidas.costo.toString().includes(queryCostoComida) &&
        comidas.hora_inicio.toLowerCase().includes(queryHoraInicio.toLowerCase()) &&
        comidas.hora_fin.toLowerCase().includes(queryHoraFin.toLowerCase())
    );
    setFilteredComidas(filtered);
  }, [allComidas, queryNombreComida, queryCostoComida, queryHoraInicio, queryHoraFin]);

  //logica para manejar el ordenamiento
  useEffect(() => {
    if (!isInit) return;
    if (sortStatus.columnAccessor === "nombre") {
      const sortedRecords = [...allComidas].sort((a, b) => {
        const nombreA = a.nombres.toLowerCase();
        const nombreB = b.nombres.toLowerCase();
        return nombreA.localeCompare(nombreB);
      });

      if (sortStatus.direction === "desc") {
        setAllComidas(sortedRecords.reverse());
      } else {
        setAllComidas(sortedRecords);
      }
    }

    if (sortStatus.columnAccessor === "costo") {
      const sortedRecords = [...allComidas].sort((a, b) => {
        const costoA = Number(a.costo);
        const costoB = Number(b.costo);
        return costoA - costoB;
      }
      );
      if (sortStatus.direction === "desc") {
        setAllComidas(sortedRecords.reverse());
      } else {
        setAllComidas(sortedRecords);
      }
    }

    
  }, [sortStatus]);

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < filteredComidas.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords(loadedRecords + BATCH_SIZE);
        setLoadingMore(false);
      }, 1000);
    }
  };

  // Asegúrate de no cargar más registros de los disponibles
  const visibleComidas = filteredComidas.slice(
    0,
    Math.min(loadedRecords, filteredComidas.length)
  );

  const editComida = (row) => {
    const { pre_comida_id, nombre, costo, hora_inicio, hora_fin} = row;
    props.setType("editar");
    props.setState({
      ...props.state,
      pre_comida_id,
      nombre,
      costo,
      hora_inicio,
      hora_fin,
    });
  };

  const onShowModal = (e) => {
    setShowModal(true);
    setSelectedComida(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedComida(null);
  };

  const onDelete = async () => {
    const { estado, pre_comida_id } = selectedComida;
    const { sms, mensaje } = await ApiDeleteComida({
      pre_comida_id,
      pre_estado: !estado,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedComida(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };


  // create a toogle to change the status 
  const toggleStatus = async (row) => {
    const { pre_comida_id, activo } = row;
    const { sms, mensaje } = await ApiActivarDesactivarComida({
      pre_comida_id,
      activo: !activo
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
  };

  // how to integrate the toogle status in the table
  const toggle = (row) => {
    return (
      // use a switch to change the status of the period and center
      <Group position="center">
        <Switch
          checked={row.activo}
          onChange={() => toggleStatus(row)}
          color="blue"
        />
      </Group>
    );
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon
          color="blue"
          onClick={() => {
            editComida(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color="red"
          onClick={() => {
            onShowModal(row);
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          <div className="row py-4 justify-content-center text-align-center ">
            Realmente desea eliminar
          </div>
          <div className="d-flex justify-content-end flex-row align-self-start my-4">
            <button
              type=""
              onClick={onClosedModal}
              className="bg-btn-vet-danger sombra mx-1"
            >
              Cancelar
            </button>
            <button
              type=""
              onClick={onDelete}
              className="bg-btn-vet sombra mx-1"
            >
              <i className="fas fa-save">Eliminar</i>
            </button>
          </div>
        </ModalDefault>
      </Group>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo "
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={allComidas.length}
          withColumnBorders
          records={visibleComidas}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          sortStatus={sortStatus}
          onSortStatusChange={setSortStatus}
          style={{ maxHeight: "430px", overflowY: "auto" }}
        />
      </div>
    </div>
  );
};

export default TablaOpciones;